import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Chip
} from '@mui/material';
import { FormatBold, TextFields } from '@mui/icons-material';
import { getButtonPresetNames, getButtonPreset } from '../textStyle';

const ButtonPresetSelector = ({ onStyleSelect, currentStyle = null, presetFilter = null }) => {
  const allButtonPresetNames = getButtonPresetNames();

  // Filter presets based on the filter prop
  const presetNames = presetFilter
    ? allButtonPresetNames.filter(presetFilter)
    : allButtonPresetNames;

  console.log('🟢 ButtonPresetSelector rendered with presets:', presetNames, 'currentStyle:', currentStyle, 'filter applied:', !!presetFilter);

  // Function to get display name for preset
  const getDisplayName = (presetName) => {
    const displayNames = {
      buttonStandard: 'Standard Button',
      buttonRounded: 'Rounded Button',
      button3D: '3D Button',
      buttonGradient: 'Gradient Button',
      buttonAction: 'Action Button'
    };
    return displayNames[presetName] || presetName.charAt(0).toUpperCase() + presetName.slice(1);
  };

  const handleStyleSelect = (presetName) => {
    const preset = getButtonPreset(presetName);
    console.log('🎨 ButtonPresetSelector: Applying preset:', presetName, preset);
    onStyleSelect(presetName, preset);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <TextFields fontSize="small" sx={{ mr: 1 }} />
        <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
          Preset Button Styles
        </Typography>
      </Box>

      <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
        Click any style to quickly apply a complete button styling set.
      </Typography>

      <Grid container spacing={1}>
        {presetNames.map((presetName) => {
          const preset = getButtonPreset(presetName);
          const isSelected = currentStyle === presetName;

          return (
            <Grid item xs={6} key={presetName}>
              <Paper
                elevation={isSelected ? 3 : 1}
                sx={{
                  p: 1.5,
                  cursor: 'pointer',
                  border: isSelected ? '2px solid #1976d2' : '1px solid #e0e0e0',
                  borderRadius: 1,
                  backgroundColor: isSelected ? '#e3f2fd' : '#ffffff',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: isSelected ? '#e3f2fd' : '#f5f5f5',
                    borderColor: '#1976d2',
                    transform: 'translateY(-1px)'
                  },
                  minWidth: 100,
                  maxWidth: 140
                }}
                onClick={() => handleStyleSelect(presetName)}
              >
                <Typography
                  variant="caption"
                  sx={{
                    ...preset,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    wordBreak: 'break-word',
                    lineHeight: 1.1,
                    fontSize: '10px',
                    // Normalize for preview
                    padding: '8px 4px !important',
                    width: '100% !important',
                    minHeight: '36px',
                    boxShadow: presetName === 'buttonAction' ? '3px 3px 0px #000' : (presetName === 'button3D' ? '0 3px 0 #a8002c' : (preset.boxShadow ? '0 2px 4px rgba(0,0,0,0.1)' : 'none')),
                    transform: presetName === 'buttonAction' ? 'skewX(-10deg) scale(0.95)' : 'none',
                    margin: '0 !important',
                    boxSizing: 'border-box'
                  }}
                >
                  {getDisplayName(presetName)}
                </Typography>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default ButtonPresetSelector; 